//3rd Party Components
import React, { Fragment } from 'react';
import moment from 'moment';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import MetaTags from 'react-meta-tags';
import { useDispatch, useSelector } from "react-redux";
import { AUcallout } from '@gov.au/callout';
import AUbutton from '@gov.au/buttons';

//Components
import CASASpinner from '../components/Portal/CASASpinner';
import Heading from '../components/CASA/Heading';
import ProfileOrganisation from '../components/Portal/ProfileOrganisation';
import SubModule from '../components/Portal/SubModule';
import Module from '../components/Portal/Module';
import Container from '../components/CASA/Container';

//Actions
import { getAppsOrganisation, FETCH_APPSORGANISATION_SUCCESS } from '../PortalStore/Actions/AppsOrganisationActions';
import { getAlertsOrganisation, FETCH_ALERTSORGANISATION_SUCCESS  } from '../PortalStore/Actions/AlertsOrganisationActions';
import { getREOCsOrganisation, FETCH_REOCSORGANISATION_SUCCESS } from '../PortalStore/Actions/REOCsOrganisationActions';
import { getDronesOrganisation, FETCH_DRONESORGANISATION_SUCCESS } from '../PortalStore/Actions/DronesOrganisationActions';
import { getAircraftOrganisation, FETCH_AIRCRAFTORGANISATION_SUCCESS } from '../PortalStore/Actions/AircraftOrganisationActions';
import { getOrganisationDetails, FETCH_ORGANISATIONDETAILS_SUCCESS } from '../PortalStore/Actions/OrganisationDetailsActions';
import { getParamValue, urlSearchValue } from '../components/Portal/Utilities';
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { IsVerifiedUserWithARN, getUserHomePage, UserMustSubmitIndividualARNApplication, UserMustVerifyPOI } from '../components/Portal/Utilities';
import { getUserDetailsSelector } from '../PortalStore/Selectors/UserDetailsSelectors';
import { getOrgDetailsSelector } from '../PortalStore/Selectors/OrgDetailsSelectors';
import { getExpirySelector, getFeatureSelector, getUrlSelector, getSystemSelector, getSnippetSelector } from '../PortalStore/Selectors/EnvDataSelectors';

export const ProfileOrgPage = () => {
    let history = useHistory();
    let dispatch = useDispatch();

    const [pageLoading, setPageLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [pageLoadedError, setPageLoadedError] = useState(false);
    const [pageLoadedErrorMessage, setPageLoadedErrorMessage] = useState("");
    const [slowLoadDone, setSlowLoadDone] = useState(false);

    let userdetails = useSelector(state => state.userdetails);
    let B2CSettings = useSelector(state => state.B2CSettings);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let draftarnsIndividual = useSelector(state => state.draftArnsIndividual);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);
    let RPAs = useSelector(state => state.dronesOrganisation);

    let appsOrganisation = useSelector(state => state.appsOrganisation);
    let alertsIndividual = useSelector(state => state.alertsIndividual);
    let alertsOrganisation = useSelector(state => state.alertsOrganisation);
    let reocsOrganisation = useSelector(state => state.reocsOrganisation);
    let dronesOrganisation = useSelector(state => state.dronesOrganisation);
    let organisationDetails = useSelector(state => state.organisationDetails);
    let aircraftOrganisation = useSelector(state => state.aircraftOrganisation);

    let urlASF = useSelector(state => getUrlSelector(state, "Portal - ASF Base URL"));
    let urlPaymentRequest = useSelector(state => getUrlSelector(state, "Portal - ASF Payment Request URL"));

    let featureRoleUserMgmt = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Role And User Management"));
    let featureDrone = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Drone"));
    let featureRecDrone = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Recreational Drone"));
    let fetaureSubDoc = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Submit Document"));

    let daysRPAexpiring = useSelector(state => getExpirySelector(state, "Portal - RPA registration expiry warning period"));
    let daysRPAexpired = useSelector(state => getExpirySelector(state, "Portal - RPA registration expired warning period"));

    let fullname = useSelector(state => getUserDetailsSelector(state, "name"));

    let pageAlert = useSelector(state => state.pageAlert);


    //todo  - refactor
    let organisationId = urlSearchValue('casaorgid');
    if (organisationId === null) {
        organisationId = getParamValue('organisationId');
    }

    if (!pageLoaded && pageAlert.level !== "") {
        dispatch(addPageAlert({ level: "", title: "", message: "" }));
    }

    useEffect(() => {
        const webappurl = B2CSettings.items.webappurlPortalApi;
        const accessToken = B2CSettings.items.accesstokenPortal;
        const webappurlF = B2CSettings.items.webappurlFormsApi;
        const droneTypes = featureRecDrone ? ['recreational', 'commercial'] : ['commercial'];

        setPageLoading(true);

        axios.all([
            dispatch(getOrganisationDetails(webappurl, accessToken, organisationId)),
            dispatch(getAppsOrganisation(webappurl, accessToken, organisationId)),
            dispatch(getAlertsOrganisation(webappurl, accessToken, organisationId)),
            dispatch(getAircraftOrganisation(webappurlF, accessToken, organisationId)),
            dispatch(getDronesOrganisation(webappurlF, accessToken, organisationId, droneTypes)),
            dispatch(getREOCsOrganisation(webappurlF, accessToken, organisationId)),
        ])
            .then(axios.spread((orgdetailsres, appsorgres, alertsorgres, aircraftorgres, dronesorgres, reocsorgres) => {
                if (orgdetailsres.type === FETCH_ORGANISATIONDETAILS_SUCCESS
                    && appsorgres.type === FETCH_APPSORGANISATION_SUCCESS
                    && alertsorgres.type === FETCH_ALERTSORGANISATION_SUCCESS
                    && aircraftorgres.type === FETCH_AIRCRAFTORGANISATION_SUCCESS
                    && dronesorgres.type === FETCH_DRONESORGANISATION_SUCCESS
                    && reocsorgres.type === FETCH_REOCSORGANISATION_SUCCESS
                ) {
                    setPageLoaded(true);
                    setPageLoading(false);
                }
                else {
                    setPageLoadedError(true);
                    setPageLoadedErrorMessage("PO.1");
                    setPageLoading(false);
                    setPageLoaded(true);

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: PO.1";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            }))
            .catch(function (error) {
                setPageLoadedError(true);
                setPageLoadedErrorMessage("PO.1");
                setPageLoading(false);
                setPageLoaded(true);

                dispatch(addPageAlert({ level: "error", title: "System error PO.1" }));
            });
        
    }, []);

    const msgexists = (item, index, arr) => {
        return item.msg.message === this.message && item.msg.level === this.level;
    }

    const PaymentRequest = () => {
        //debugger;
        var paymentSubs = 0; //{{ orgsubs_PaymentRequired.size }};

        if (paymentSubs === 0) {
            //return null;
        }

        var linkPayment = "/forms/organisation/" + organisationId + "/" + urlPaymentRequest;

        return (
            <div className="casa-dashboard-row row">
                <AUcallout title="">
                    <h3>Payment required</h3>
                    <br />
                    <p>After review and assessment of your recently submitted application/s, you have items requiring payment.</p>
                    <br />
                    <br />
                    <AUbutton link={linkPayment}>
                        Review payment details
                    </AUbutton>
                </AUcallout>
            </div>
        );
    }

    const DronesAndRPA = () => {
        /* Visibility rule */

        //if (this.ARNPending()) {
        //    return null;
        //}

        /* If repl suspended and drones not available show nothing */
        //var indLicences = licencesIndividual.items;
        //if (indLicences && indLicences.length > 0 && indLicences[0]["cattype.casa_name"].toLowerCase() === "other" && indLicences[0]["lictype.casa_name"].toLowerCase() === "repl") {
        //    var availDate = moment(this.featureDrone, "DD/MM/YYYY");
        //    var available = availDate.isBefore();
        //    if (!available) return null;
        //}

        return (
            <Module name="Drones and <abbr title='Remotely Piloted Aircraft'>RPA</abbr>">

                {RPA()}

                {ExcludedCategoryNotification()}

            </Module>
        );

    }

    const RPA = () => {

        /* Visibility Rule */

        /* Current user is a valid participant (directly or via certificate) */
        if (!participants.items.hasParticipants) {
            return null;
        }

        /* org has an ARN */
        let participant = participants.items.participantsAll.find(el => el["account.accountid"] === organisationId);
        if (participant != null) {
            if (participant["account.casa_arn"] == null) {
                return null;
            }
        } else {
            return null;
        }

        /* Current user is a Chief Executive Officer,Chief Remote Pilot,Maintenance Controller,Authorised Representative for Organisation */
        let certrole = false;
        participant = participants.items.participantsCerts.find(el => el["account.accountid"] === organisationId);

        if (participant && participant.roleCert &&
            (participant.roleCert.includes("Chief Executive Officer") ||
                participant.roleCert.includes("Chief Remote Pilot") ||
                participant.roleCert.includes("Authorised Representative") ||
                participant.roleCert.includes("Maintenance Controller"))) {
            certrole = true;
        }

        //if (!certrole) {
        //    return null;
        //}

        /* drones feature is enabled */
        let availDate = moment(featureDrone, "DD/MM/YYYY");
        let available = availDate.isBefore();
        //if (!available) return;

        let jparams = {
            from: "org",
            organisationId: organisationId
        }
        let linkrpa = "/orgmanagerpa?standalone=" + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)));

        //{% if orgHasCert %}
        //var linkrpa = "/orgmanagerpa?casaorgid={{orgid}}&hasCert=1";
        //{% else %}
        //var linkrpa = "/orgmanagerpa?casaorgid={{orgid}}&hasCert=0";
        //{% endif %}

        let orgDrones = dronesOrganisation.items;
        let orgDronesCount = dronesOrganisation.items.value ? dronesOrganisation.items.value.length : 0;

        let count = 0;
        let messagesDrone = [];

        let expiringRPA = moment().startOf('day').add(daysRPAexpiring, 'days').subtract(1, 'days');
        let expiredRPA = moment().endOf('day').subtract(daysRPAexpired, 'days');
        var todayStart = moment().startOf('day');

        if (orgDrones.value && orgDrones.value.length > 0) {
            // check drones expiring for this organisation
            let warning = false;
            for (let i = 0; i < orgDronesCount; i++) {
                let validUntilEnd = moment(orgDrones.value[i]["casa_validuntil"], "YYYY-MM-DD").endOf('day');
                let validUntilStart = moment(orgDrones.value[i]["casa_validuntil"], "YYYY-MM-DD").startOf('day');

                if (validUntilEnd < todayStart && expiredRPA < validUntilStart) {
                    // expired
                    warning = true;
                }
                if (expiringRPA > validUntilStart && validUntilStart >= todayStart) {
                    // expiring
                    warning = true;
                    count++;
                }
                if (validUntilStart >= todayStart && validUntilStart > expiringRPA) {
                    count++;
                }

                orgDrones.value[i].expiryWarning = warning;
            }

            if (orgDrones.value.findIndex(item => item.expiryWarning) !== -1) {
                let msg = { "message": "Items expiring soon", "level": "warning" };
                if (!messagesDrone.some(msgexists, msg)) {
                    messagesDrone.push({ 'msg': msg });
                }
            }
        }

        let name = "Drone registration";
        let description1;
        if (count > 0) {
            name = "Manage registered drones";
            if (count === 1) {
                description1 = { 'message': "1 registered drone and <abbr title='Remotely Piloted Aircraft'>RPA</abbr>", 'level': '', 'msgs': [] };
            }
            else {
                description1 = { 'message': count + " registered drones and <abbr title='Remotely Piloted Aircraft'>RPA</abbr>", 'level': '', 'msgs': [] };
            }
        }
        else {
            description1 = { 'message': "Register your drones (<abbr title='Remotely Piloted Aircraft'>RPA</abbr>)", 'level': '', 'msgs': [] };
        }

        let dronesinprog = appsOrganisation && appsOrganisation.items && appsOrganisation.items.inprogdrones && appsOrganisation.items.inprogdrones.length > 0;

        if (count > 0 && dronesinprog) {
            description1 = { 'message': description1.message + "<br/>1 or more in-progress registered drones and <abbr title='Remotely Piloted Aircraft'>RPA</abbr>", 'level': '', 'msgs': messagesDrone };
        }

        if (count === 0 && !dronesinprog) {
            description1 = { 'message': "Register your drones (<abbr title='Remotely Piloted Aircraft'>RPA</abbr>)", 'level': '', 'msgs': [] };
        }

        return (
            <SubModule
                name={name}
                link={linkrpa}
                description1={description1}
                messages={messagesDrone}/>
        )

    }

    const ExcludedCategoryNotification = () => {
        return null;
    }


    const RoleAndUserManagement = () => {

        /* feature is enabled */
        var availDate = moment(featureRoleUserMgmt, "DD/MM/YYYY");
        var available = availDate.isBefore();
        if (!available) return null;

        var name = "Role and user management";
        var description = "Manage roles and users";

        var crumbs = [
            {
                link: "/dashorg?casaorgid=" + organisationId,
                text: 'myCASA'
            }
        ];

        var params = {
            'organisationId': organisationId,
            'breadcrumbs': crumbs
        };

        var linkorgroles = "/orgmanageusers?casaorgid=" + organisationId + "&params=" + encodeURIComponent(btoa(JSON.stringify(params)));

        var message1 = { 'message': description, 'level': '', 'msgs': [] };

        return React.createElement(Module, {
            name: name
        },
            React.createElement(SubModule, {
                name: "Roles and users",
                link: linkorgroles,
                messages: [],
                description1: message1
            }));
    }

    const Aircraft = () => {

        /* Visibility Rule */
        //if (this.ARNPending()) {
        //    return null;
        //}

        if (!(aircraftOrganisation.items?.aircraft?.value && aircraftOrganisation.items?.gliders?.value)) {
            return null;
        }

        let tomorrow = moment().add(1, 'days');
        let today = moment().startOf('day');
        let planes = 0;
        let gliders = 0;

        for (let a = 0; a < aircraftOrganisation.items.aircraft.value.length; a++) {
            let aircraft = aircraftOrganisation.items.aircraft.value[a];
            let activeto = moment(aircraft["participant.casa_validuntil"], "YYYY-MM-DD").startOf('day');
            let activefrom = moment(aircraft["participant.casa_validfrom"], "YYYY-MM-DD").startOf('day');

            if ((activeto.isValid() === false || activeto > today)
                && (activefrom.isValid() === false || activefrom < tomorrow)) {
                planes++;
            }
        }

        for (let g = 0; g < aircraftOrganisation.items.gliders.value.length; g++) {
            let glider = aircraftOrganisation.items.gliders.value[g];
            let activeto = moment(glider["participant.casa_validuntil"], "YYYY-MM-DD").startOf('day');
            let activefrom = moment(glider["participant.casa_validfrom"], "YYYY-MM-DD").startOf('day');

            if ((activeto.isValid() === false || activeto > today)
                && (activefrom.isValid() === false || activefrom < tomorrow)) {
                gliders++;
            }
        }

        //don't show if no aircraft
        if (planes + gliders === 0) {
            return null;
        }

        let message = (planes + gliders) + " registered aircraft";

        let msgs = [];
        let msg = {};
        if (planes > 0 && appsOrganisation.items.census && appsOrganisation.items.census.length === 0) {
            msg = { "message": "Items for review", "level": "warning" };
            msgs.push({ 'msg': msg });
        }

        let description1 = { 'message': message, 'level': '', 'msgs': [] };

        let jparams = {
            organisationId: organisationId
        }
        let linkaircraft = "/manageaircraftorg?standalone=" + B2CSettings.items.standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)));

        return (
            <Module name="Aircraft">

                <SubModule
                    name="Manage aircraft"
                    link={linkaircraft}
                    messages={msgs}
                    description1={description1} />

            </Module>
        )
    }

    const ApplicationsAndNotification = () => {

        return (
            <Module name="Applications and Notifications">

                {SubmitDocument()}

            </Module>

        )
    }

    const SubmitDocument = () => {

        /* Visibility Rule */

        /* 
            Only available for roles CEO and authorised representative.
        */

        //if (!isCeoOrAuthRep) {
        //    return;
        //}

        /* feature is enabled */
        var availDate = moment(fetaureSubDoc, "DD/MM/YYYY");
        var available = availDate.isBefore();
        if (!available) return null;

        var crumbs = [
            {
                link: "/dashorg?casaorgid=" + organisationId,
                text: 'myCASA'
            }
        ];

        let participant = participants.items.participantsAll.find(el => el["account.accountid"] === organisationId);
        var params = {
            'organisationId': organisationId,
            'organisationArn': participant["account.casa_arn"],
            'breadcrumbs': crumbs
        };

        var linksubmit = "/industry-assist" + "?params=" + encodeURIComponent(btoa(JSON.stringify(params)));

        var message1 = { 'message': "Upload and submit notifications, forms, manuals and other documents", 'level': '', 'msgs': [] };

        return (
            <SubModule
                name="Submit documents and notifications to CASA"
                link={linksubmit}
                description1={message1}
                messages={[]} />
            )
        

    }
   
    const showSpinner = () => {
        if (!pageLoadedError) {
            return (<CASASpinner message="Working. Please wait....." />);
        }
        else {
            return null;
        }
    }


    let participant = participants.items.participantsAll.find(el => el["account.accountid"] === organisationId);
    //let orgarn = "";
    //if (participant != null) {
    //    if (participant.arn != null) {
    //        orgarn = participant["organisation.casa_arn"];
    //    }
    //} 
    //debugger;

    let items = [];
    let showItems = false;

    if (!pageLoaded) {

        return (
            <Fragment>
                <MetaTags>
                    <title>Organisation Profile</title>
                </MetaTags>

                <ProfileOrganisation arn={participant["account.casa_arn"]} name={participant["account.name"]} participant={participant} user={fullname} standalone={standalone} />

                <Heading
                    id="dashboardheading"
                    text="Welcome to myCASA"
                    breadcrumbs={items}
                    showcrumbs={showItems}
                    showback={false} />

                <Container show={true}>
                    {showSpinner()}
                </Container>


            </Fragment>)

    }
    else {
        return (
            <Fragment>
                <MetaTags>
                    <title>Organisation Profile</title>
                </MetaTags>

                <ProfileOrganisation arn={participant["account.casa_arn"]} name={participant["account.name"]} participant={participant} user={fullname} standalone={standalone} />

                <Heading
                    text="Welcome to myCASA"
                    breadcrumbs={items}
                    showcrumbs={showItems}
                    showback={false} />

                <Container show={true}>

                    {PaymentRequest()}

                    {Aircraft()}

                    {DronesAndRPA()}

                    {RoleAndUserManagement()}

                    {ApplicationsAndNotification()}


                </Container>

            </Fragment>
        );
    }
}